import React from 'react';
import DataTable from 'react-data-table-component';

function renderDataTable(
  filteredData,
  column,
  pending,
  currentPage,
  setPageLimit,
  setCurrentPage,
  totalPages,
  pageLimit,
  setResetSearch,
) {
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: '#f97316',
        borderBottom: '1px solid #f97316',
      },
    },
    headCells: {
      style: {
        color: '#ffffff',
        fontWeight: 700,
        fontSize: '0.86rem',
        textTransform: 'uppercase',
        letterSpacing: '0.02em',
        borderRight: '1px solid rgba(255,255,255,0.4)',
        backgroundColor: '#f97316',
      },
    },
    rows: {
      style: {
        minHeight: '52px',
        borderBottom: '1px solid #f3f4f6',
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #f3f4f6',
        color: '#1f2937',
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #fed7aa',
        backgroundColor: '#fff',
      },
    },
  };

  return (
    <div>
      {filteredData.length > 0 ? (
        <DataTable
          data={filteredData}
          columns={column}
          className="table-bordered table-responsive"
          striped
          responsive
          highlightOnHover
          pointerOnHover
          customStyles={customStyles}
          progressPending={pending}
          progressComponent={<h6 className='py-10 bg-[#FFF] text-black font-bold w-full flex items-center justify-center border'>Processing data..........</h6>}
          pagination
          paginationServer
          paginationTotalRows={totalPages}
          paginationPerPage={pageLimit}
          onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
            setPageLimit(currentRowsPerPage);
            setCurrentPage(currentPage);
            setResetSearch((prevReset) => !prevReset);
          }}
          paginationDefaultPage={currentPage}
          onChangePage={(page) => { setCurrentPage(page); setResetSearch((prevReset) => !prevReset); }}
        />
      ) : (
        <>
          <div className="table-responsive" style={{ position: 'relative' }}>
            <table className='table table-bordered table-condensed all_tab' >
              <thead style={{ backgroundColor: '#f97316' }}>
                <tr>
                  {column.map((column) => (

                    !column.omit &&
                    <th key={column.name} style={{ backgroundColor: '#f97316', color: '#ffffff', fontWeight: 700 }}>{column.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr style={{ textAlign: 'center', backgroundColor: '#f9f9f9' }}>
                  <td colSpan={column.length} style={{ padding: '8px 5px' }}>No data available in table</td>
                </tr>
              </tbody>
            </table>
            <div className="d_processing" style={{ display: pending ? 'block' : 'none' }}>Processing...</div>
          </div>
        </>
      )}
    </div>
  );
}

export default renderDataTable;

